// 所有Stack.Screen配置集中管理
import { DeviceEventEmitter } from "~/ui/primitives"
import type { NativeStackNavigationOptions } from "@react-navigation/native-stack"
import type { NativeStackScreenProps } from "@react-navigation/native-stack"
import AddGroupChatScreen from "~pages/app-stack/add-group-chat"
import AddGroupMemberScreen from "~pages/app-stack/add-group-member"
import RemoveGroupMemberScreen from "~pages/app-stack/remove-group-member"
import GroupChatManagementScreen from "~pages/app-stack/add-group-chat/group-chat-management"
import GroupChatInformationScreen from "~pages/app-stack/add-group-chat/group-chat-information"
import GroupChatAnnouncementDetailScreen from "~pages/app-stack/add-group-chat/group-announcement-detail"
import RevenueStatisticsScreen from "~pages/app-stack/revenue-statistics"
import UpdateGroupTitleScreen from "~pages/app-stack/update-group-title"
import AddContactScreen from "~pages/app-stack/add-contact"
import AddChannelScreen from "~pages/app-stack/add-channel-chat"
import ChannelChatManagementScreen from "~pages/app-stack/add-channel-chat/channel-chat-management"
import ChannelChatInformationScreen from "~pages/app-stack/add-channel-chat/channel-chat-information"
import FriendListScreen from "~pages/app-stack/friend-list"
import ChannelListScreen from "~pages/app-stack/channel-list"
import GroupListScreen from "~pages/app-stack/group-list"
import GroupCardScreen from "~pages/app-stack/group-card"
import QrcodeScanScreen from "~pages/app-stack/qrcode-scan"
import SettingScreen from "~pages/app-stack/setting"
import BasicInfoScreen from "~pages/app-stack/basic-info"
import AvatarScreen from "~pages/app-stack/avatar"
import UpdateCurrentUserEmailScreen from "~pages/app-stack/update-current-user-email"
import UpdateCurrentUserGenderScreen from "~pages/app-stack/update-current-user-gender"
import PersonalCardScreen from "~pages/app-stack/personal-card"
import FindChatRecordScreen from "~pages/app-stack/find-chat-recoed"
import SearchChatContentScreen from "~pages/app-stack/search-chat-content"
import UpdateContactScreen from "~pages/app-stack/update-contact"
import InfoScreen from "~pages/app-stack/info"
import AccusationScreen from "~pages/app-stack/accusation"
import AccusationSuccessScreen from "~pages/app-stack/accusation-success"
import PrivacyAndSafetyScreen from "~pages/app-stack/privacy-and-safety"
import MyAccountScreen from "~pages/app-stack/my-account"
import ShareScreen from "~pages/app-stack/share"
import ImageGalleryScreen from "~pages/app-stack/image-gallery"
import VideoRecorderScreen from "~pages/app-stack/video-recorder"
import { CustomerButton, CustomerAddButton } from "~components/customer"
import NoticeCenterScreen from "~pages/app-stack/notice-center"
import SecurityGoogleScreen from "~pages/app-stack/setting/security-google"
import GroupAssistantScreen from "~pages/app-stack/setting/group-assistant"
import NotDisturbModeScreen from "~pages/app-stack/setting/not-disturb-mode"
import LoginDeviceScreen from "~pages/app-stack/setting/login-device"
import OnlineTimeSettingsScreen from "~pages/app-stack/setting/online-time-settings"
import SelfDestructTimeSettingsScreen from "~pages/app-stack/setting/self-destruct-time-settings"
import AddMethodSettingsScreen from "~pages/app-stack/setting/add-method-settings"
import BlackListScreen from "~pages/app-stack/setting/black-list"
import { Text, CenterFlex } from "~components/El"
import { globalToast } from "~utils"
import NotificationBellScreen from "~pages/app-stack/setting/notification-bell"
import LanguageSettingsScreen from "~pages/app-stack/setting/language-settings"
import FontsizeSettingsScreen from "~pages/app-stack/setting/fontsize-settings"
import ClearCacheDataScreen from "~pages/app-stack/setting/clear-cache-data"
import ForwardMessageScreen from "~pages/app-stack/forward-message"
import AutoRedPacketBetSettingScreen from "~pages/app-stack/auto-red-packet-bet-setting"
import { useChatList } from "~hooks/useChatList"
import { useStores } from "~models"

type ScreenOptionsProps = {
  navigation: NativeStackScreenProps<any>["navigation"]
  route: NativeStackScreenProps<any>["route"]
}

export const appScreens = [
  { name: "AddGroupChat", component: AddGroupChatScreen, options: { title: "创建群聊" } },
  {
    name: "AutoRedPacketBetSetting",
    component: AutoRedPacketBetSettingScreen,
    options: { title: "设置自动发红包下注" },
  },
  {
    name: "GroupChatManagement",
    component: GroupChatManagementScreen,
    options: { title: "群聊管理" },
  },
  {
    name: "GroupChatInformation",
    component: GroupChatInformationScreen,
    options: { title: "群聊信息" },
  },
  {
    name: "GroupAnnouncementDetail",
    component: GroupChatAnnouncementDetailScreen,
    options: ({ route }: ScreenOptionsProps): NativeStackNavigationOptions => ({
      title: route.params?.title ?? "群公告",
    }),
  },
  {
    name: "RevenueStatistics",
    component: RevenueStatisticsScreen,
    options: ({ route }) => ({
      title: "收益统计",
      headerTitle: () => (
        <CenterFlex flexDirection="column">
          <Text color="text" fontWeight="600" fontSize="16px">
            收益统计
          </Text>
          <Text color="secondaryText" fontSize="12px">
            {route.params?.item?.name || ""}
          </Text>
        </CenterFlex>
      ),
    }),
  },
  { name: "AddGroupMember", component: AddGroupMemberScreen, options: { title: "加入联系人" } },
  { name: "AddChannel", component: AddChannelScreen, options: { title: "创建频道" } },
  {
    name: "ChannelChatInformation",
    component: ChannelChatInformationScreen,
    options: { title: "频道信息" },
  },
  {
    name: "ChannelChatManagement",
    component: ChannelChatManagementScreen,
    options: { title: "频道管理" },
  },
  {
    name: "RemoveGroupMember",
    component: RemoveGroupMemberScreen,
    options: { title: "移除联系人" },
  },
  {
    name: "UpdateGroupTitle",
    component: UpdateGroupTitleScreen,
    options: { headerShown: false, presentation: "modal" },
  },
  { name: "AddContact", component: AddContactScreen, options: { title: "添加好友" } },
  { name: "FriendList", component: FriendListScreen, options: { title: "新朋友" } },
  { name: "ChannelList", component: ChannelListScreen, options: { title: "频道" } },
  { name: "GroupList", component: GroupListScreen, options: { title: "群聊" } },
  {
    name: "GroupCard",
    component: GroupCardScreen,
    options: ({ route }: ScreenOptionsProps): NativeStackNavigationOptions => ({
      title: route.params?.title ?? "群聊名片",
    }),
  },
  { name: "QrcodeScan", component: QrcodeScanScreen, options: { title: "扫描二维码" } },
  {
    name: "Setting",
    component: SettingScreen,
    options: ({ route }: ScreenOptionsProps): NativeStackNavigationOptions => ({
      title: route.params?.title ?? "设置",
    }),
  },
  { name: "BasicInfo", component: BasicInfoScreen, options: { title: "个人信息" } },
  { name: "Avatar", component: AvatarScreen, options: { title: "个人头像" } },
  {
    name: "UpdateCurrentUserEmail",
    component: UpdateCurrentUserEmailScreen,
    options: { title: "绑定邮箱" },
  },
  {
    name: "UpdateCurrentUserGender",
    component: UpdateCurrentUserGenderScreen,
    options: { headerShown: false, presentation: "modal" },
  },
  { name: "PersonalCard", component: PersonalCardScreen, options: { title: "个人信息" } },
  { name: "FindChatRecord", component: FindChatRecordScreen, options: { title: "查找聊天记录" } },
  {
    name: "SearchChatContent",
    component: SearchChatContentScreen,
    options: { title: "搜索聊天内容" },
  },
  {
    name: "UpdateContact",
    component: UpdateContactScreen,
    options: { headerShown: false, presentation: "modal" },
  },
  { name: "Info", component: InfoScreen, options: { title: "资料设置" } },
  { name: "Accusation", component: AccusationScreen, options: { title: "举报" } },
  { name: "AccusationSuccess", component: AccusationSuccessScreen, options: { title: "举报成功" } },
  { name: "PrivacyAndSafety", component: PrivacyAndSafetyScreen, options: { title: "隐私安全" } },
  {
    name: "NoticeCenter",
    component: NoticeCenterScreen,
    options: {
      title: "通知中心",
      headerRight: () => {
        const { apiStore, notificationStore } = useStores()
        return (
          <CenterFlex padding="0 10px">
            <Text
              color="primary"
              fontSize="14px"
              fontWeight="600"
              onClick={async () => {
                try {
                  const { read, list } = await apiStore.markAllNotificationsAsReadAndRefreshList(
                    {},
                    { page: 1, limit: 20 },
                  )
                  if (!read) return
                  notificationStore.refreshUserUnreadNotificationCount()
                  const result = Array.isArray(list?.data) ? list.data : []
                  DeviceEventEmitter.emit("RefreshNoticeCenterList", result)
                  // globalToast.show("已全部标记为已读")
                } catch (err: any) {
                  globalToast.show(err?.message || "操作失败")
                }
              }}
            >
              全部已读
            </Text>
          </CenterFlex>
        )
      },
    },
  },
  { name: "MyAccount", component: MyAccountScreen, options: { title: "我的账号" } },
  { name: "VideoRecorder", component: VideoRecorderScreen, options: { title: "录影" } },
  { name: "ImageGallery", component: ImageGalleryScreen, options: { title: "图片/视频预览" } },
  {
    name: "Share",
    component: ShareScreen,
    options: ({ navigation }: ScreenOptionsProps): NativeStackNavigationOptions => ({
      title: "分享",
      headerRight: () => (
        <CustomerButton
          onClick={() => DeviceEventEmitter.emit("ChatEvent")}
          onPressOutside={() => navigation.navigate("Wallet")}
        />
      ),
    }),
  },
  { name: "SecurityGoogle", component: SecurityGoogleScreen, options: { title: "启用谷歌验证器" } },
  { name: "GroupAssistant", component: GroupAssistantScreen, options: { title: "群发助手" } },
  { name: "NotDisturbMode", component: NotDisturbModeScreen, options: { title: "免打扰模式" } },
  { name: "NotificationBell", component: NotificationBellScreen, options: { title: "通知铃声" } },
  { name: "LanguageSettings", component: LanguageSettingsScreen, options: { title: "语言" } },
  { name: "FontsizeSettings", component: FontsizeSettingsScreen, options: { title: "字体大小" } },
  { name: "LoginDevice", component: LoginDeviceScreen, options: { title: "登录设备" } },
  { name: "ClearCacheData", component: ClearCacheDataScreen, options: { title: "数据清理" } },
  {
    name: "OnlineTimeSettings",
    component: OnlineTimeSettingsScreen,
    options: { title: "上线时间设置" },
  },
  {
    name: "SelfDestructTimeSettings",
    component: SelfDestructTimeSettingsScreen,
    options: { title: "自毁时间设置" },
  },
  {
    name: "AddMethodSettings",
    component: AddMethodSettingsScreen,
    options: { title: "添加方式设置" },
  },
  {
    name: "BlackList",
    component: BlackListScreen,
    options: ({ route }: ScreenOptionsProps): NativeStackNavigationOptions => ({
      title: "黑名单管理",
      headerRight: () => {
        const { openBlackListView } = useChatList()
        const { blackListStore, userStore } = useStores()
        const currentUser = userStore.currentUser
        return (
          <CustomerAddButton
            onClick={() => {
              openBlackListView({
                title: "选择屏蔽用户",
                confirmText: "屏蔽",
                onConfirm: (contacts) => {
                  contacts.forEach((contact) => {
                    blackListStore.addBlacklist(contact.user_id)
                  })
                  blackListStore.queryBlacklistList(currentUser?.id)
                },
              })
            }}
          />
        )
      },
    }),
  },
  { name: "ForwardMessage", component: ForwardMessageScreen, options: { title: "转发消息" } },
]
